import React, {useEffect, useState} from 'react';
import {useLazyQuery, useMutation, useQuery} from '@apollo/client';
import {MUTATION_STUDY_PASS_PHONETICS} from '../Lesson/graphql';
import {QUERY_STUDY_LIST} from '../Study/graphql';
import {QUERY_USER} from '../Client/graphql';
import {isActive} from '../Client/utils';
import Joyride from "react-joyride";
import { locale } from '../../utils/joyride';

const DetailPhonetics = ({nextRun, study, content}) => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    setRun(!!(study && !study.phoneticsPassed && nextRun === 'phonetics'));
  }, [nextRun]);

  const {user} = useQuery(QUERY_USER).data;

  const [getStudies] = useLazyQuery(QUERY_STUDY_LIST, {fetchPolicy: 'cache-and-network'});

  const [mutation, {loading}] = useMutation(MUTATION_STUDY_PASS_PHONETICS, {
    onCompleted: data => {
      if (data && data.studyPassPhonetics.obj) {
        const {vocabularyPassed, trialPassed, finalPassed, phoneticsPassed} = data.studyPassPhonetics.obj;
        if (vocabularyPassed && trialPassed && finalPassed && phoneticsPassed) {
          getStudies();
        }
      }
    },
  });

  useEffect(() => {
    window.listenAudio();
  }, []);

  return (
    <div className="row justify-content-center">
      <Joyride 
        run={run}
        locale={locale} 
        scrollOffset={80} 
        steps={[
          {
            target: '.phonetics-content',
            content: 'В фонетике мы будем знакомиться с особенностями произношения. Прочтите материал. Так как это Урок - вступление, объем материала короткий',
            disableBeacon: true,
          },
          {
            target: '.btn-phonetics',
            content: 'Теперь нажмите "Завершить чтение"',
            disableBeacon: true,
          },
        ]}
      />
      <div className="col-lg-9">
        <div className="mb-4 overflow-auto phonetics-content" dangerouslySetInnerHTML={{__html: content}} />
        <button
          disabled={study && study.phoneticsPassed}
          onClick={e => {
            e.preventDefault();
            mutation({variables: {input: {id: study && study.id}}});
          }}
          className={`btn btn-phonetics btn-${study && study.phoneticsPassed ? 'success' : 'primary'}`}
        >
          {study && study.phoneticsPassed ? 'Прочитано' : loading ? 'Завершить чтение ...' : 'Завершить чтение'}
        </button>
      </div>
    </div>
  );
};

export default DetailPhonetics;
